import(/* webpackMode: "eager" */ "/home/ubuntu/apps/dotadmin/src/app/error.tsx");
